import { createFileRoute } from '@tanstack/react-router';

import { TariffPage } from '../modules/location-tariffs/ui/pages/TariffPage';

// NOTE: .index.tsx suffix is REQUIRED here (same pattern as zones + assignments routes).
// Without the .index suffix, TanStack Router treats the file as a layout component
// and wraps child routes instead of rendering the page. See JQ4-11 WU-13 gotcha.
export const Route = createFileRoute('/_authenticated/dashboard/locations/$locationId/tariff/')({
  component: TariffPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'Tariff'],
  },
});
